import React from 'react';
import {IdMirrorCard} from './id-mirror-card';
import {DarkC1Image, LightC1Image} from '../../../data/id-mirror-data';

const titleDark = 'Un grande, aún más grande';
const descriptionDark = (
  <>
    <b>
      Siendo inconfundiblemente un Polo, crece aún más en su interior gracias a
      la plataforma MEB+.
    </b>{' '}
    {/* Con las dimensiones del Polo actual, ahora tendrás más espacio y comodidad
    con un maletero de hasta 410L para llevar lo que quieras. */}
  </>
);

const titleLight = 'Simplemente Polo';
const descriptionLight = (
  <>
    <b>
      Diseño 100% Volkswagen que reconoces al instante, con el carácter que
      define al Polo desde el primer día.
    </b>{' '}
    {/* El compacto de siempre para moverte por cualquier sitio con completa
    agilidad. */}
  </>
);

export const Card1 = ({
  isMobileCard = false,
  cardInfoDarkRef,
  cardInfoLightRef,
}: {
  isMobileCard?: boolean;
  cardInfoLightRef?: React.Ref<HTMLDivElement>;
  cardInfoDarkRef?: React.Ref<HTMLDivElement>;
}) => {
  return (
    <IdMirrorCard
      titleLight={titleLight}
      descriptionLight={descriptionLight}
      imageLight={LightC1Image}
      titleDark={titleDark}
      descriptionDark={descriptionDark}
      imageDark={DarkC1Image}
      cardNumber={'1'}
      isMobileCard={isMobileCard}
      cardInfoDarkRef={cardInfoDarkRef}
      cardInfoLightRef={cardInfoLightRef}
    />
  );
};
